import { render } from "./CreateModal.vue?vue&type=template&id=529c9db4&scoped=true"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"

import "./CreateModal.vue?vue&type=style&index=0&id=529c9db4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529c9db4"]])

export default __exports__